'use strict';

const { addGetOperation } = require('../../queries');
const addUserExternalDdasQueries = require('../../queries/configs/UserExternalDdas');

function UserExternalDdas({ client, fspId }) {

  const UserExternalDdasOperations = {
    returnModel: {
      name: 'userExternalDda',
    },
    baseUrl: `/fsps/${fspId}/userexternalddas`,

  };

  const UserExternalDdasCreator = addGetOperation(client, UserExternalDdasOperations, function ExternalDda(ddaId) {
    return {
      update: function (data, queryParams, cb) {
        return client.executeRequest('POST', `${UserExternalDdasOperations.baseUrl}/${ddaId}`, {
          data,
          queryParams,
          cb,
          returnModel: UserExternalDdasOperations.returnModel,
        });
      },
      delete: function (queryParams, cb) {
        return client.executeRequest('DELETE', `${UserExternalDdasOperations.baseUrl}/${ddaId}`, {
          queryParams,
          cb,
          returnModel: UserExternalDdasOperations.returnModel,
        });
      },

    };
  });

  return Object.assign(UserExternalDdasCreator, UserExternalDdasOperations);
}

module.exports = addUserExternalDdasQueries(UserExternalDdas);
